import { getChangeUpOrDownArrow } from '../TransactionSystem/Dashboard/MyHoldings'
import Text from '@/stories/components/Common/NewText'
import { StencilCDNImage } from '@/components/Common/StencilImage'

interface HeaderSectionProps {
  logo: string
  name: string
  symbol: string
  livePriceNumber?: number
  dayChangePerc?: number
}

const HeaderSection = ({
  logo,
  name,
  symbol,
  livePriceNumber,
  dayChangePerc,
}: HeaderSectionProps) => {
  return (
    <section className="bg-brand-white mt-4 rounded-2xl py-4 md:py-6">
      <div className="flex items-center">
        <div className="flex">
          <div>
            <div className="flex flex-col items-center text-center md:block md:text-left">
              {logo && (
                <StencilCDNImage
                  src={logo}
                  alt={`${name} logo`}
                  width={48}
                  height={48}
                  className="mr-2 rounded-full"
                />
              )}
            </div>
          </div>
          <div className="ml-2 font-medium">
            {name && (
              <Text appearance="heading1" tag="h1">
                {`${name} (${symbol})`}
              </Text>
            )}

            <p className="md:text-20px text-base">
              {typeof livePriceNumber === 'number' &&
                typeof dayChangePerc === 'number' && (
                  <span className="whitespace-prewrap overflow-hidden text-ellipsis text-left text-sm">
                    <span className="text-brand-grey-base mr-2">
                      {'Price: '}₹{livePriceNumber.toFixed(2)}{' '}
                    </span>
                    <span
                      className={`${
                        dayChangePerc >= 0
                          ? 'text-brand-green-dark'
                          : 'text-brand-red-cinnabar'
                      } inline-flex items-center`}
                    >
                      {getChangeUpOrDownArrow(dayChangePerc)}
                      {dayChangePerc.toFixed(2)}%
                    </span>
                  </span>
                )}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeaderSection
